import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { GENERAL_INCOME_TYPE_PATH } from '../../../../config/paths';
import GeneralIncomeTypeDeleteButton from './GeneralIncomeTypeDeleteButton';

const GeneralIncomeTypeToolbar = ({ generalIncomeTypeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${GENERAL_INCOME_TYPE_PATH}/${generalIncomeTypeId}/edit`} />{' '}
      <GeneralIncomeTypeDeleteButton generalIncomeTypeId={generalIncomeTypeId} />
    </div>
  </ButtonToolbar>
);

GeneralIncomeTypeToolbar.propTypes = {
  generalIncomeTypeId: PropTypes.number.isRequired,
};

export default GeneralIncomeTypeToolbar;
